export default __webpack_public_path__ + "static/media/cf_broken_heart.552900a6.svg";